import React from 'react';
import PropTypes from 'prop-types';
import StepHeader from '../../includes/StepHeader';
import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';
import ManagePaymentActionCreator from '../../actions/ManagePaymentActionCreator';
import EditPaymentsStore_new from '../../stores/EditPaymentsStore_new';
import EditSinglePayment from './EditPayment/EditSinglePayment';
import EditSOPayment from './EditPayment/EditSOPayment';
import ManagePaymentBL from './ManagePaymentBL';
import StringConstant from '../../constants/StringConstants';
import NumberUtils from '../../utils/NumberUtils';
import Helmet from 'react-helmet';
import ErrorPopUpComponent from '../common/ErrorPopUpComponent';
import LoaderComponent from '../common/LoaderComponent';
import HashcodeUtils from '../../utils/HashcodeUtils';
import SessionStore from '../../stores/SessionStore';
import AppStore from '../../stores/AppStore';
import envConfig from '../../../static/config';
import PatternLibModalComponent from '../common/modals/PatternLibModalComponent';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';
import VerificationContainer from '../verification/VerificationContainer';
import SessionActionCreator from '../../actions/SessionActionCreator';
import DateUtils from '../../utils/DateUtils';
import { getCookieContent } from '../../utils/BiocatchUtils';

export const ROUTE_EDIT_PAYMENT = 'WEB-EDIT-PAYMENT';

class EditPayment extends React.Component {
  constructor(props) {
    super(props);
    const paymentData = EditPaymentsStore_new.getPaymentData();
    this.editPayment = this.editPayment.bind(this);
    this.closeErrorPopup = this.closeErrorPopup.bind(this);
    this.errorPopup = this.errorPopup.bind(this);
    const defaultValue = DateUtils.getShortString();
    this.onEditStoreChange = this.onEditStoreChange.bind(this);
    this.showContent = this.showContent.bind(this);
    this.handleTokenResponse = this.handleTokenResponse.bind(this);
    this.renderSoftTokenAlternative =
      this.renderSoftTokenAlternative.bind(this);
    this.handleErrorResponse = this.handleErrorResponse.bind(this);
    this.renderMaxOtpReachedModal = this.renderMaxOtpReachedModal.bind(this);
    this.state = {
      activeData: paymentData,
      showCancelPaymentModal: false,
      defaultValue,
      editedData: paymentData,
      showLoader: false,
      showError: false,
      isContinueDisabled: true,
      showSoftTokenAlternative: false,
      showMaxOTPReachedModal: false,
    };
  }

  componentWillMount() {
    EditPaymentsStore_new.addChangeListener(this.onEditStoreChange);
    window.addEventListener('message', this.handleTokenResponse);
  }

  componentDidMount() {
    sayLandingMessage(
      `${this.props.content.viewPaymentHeader}${StringConstant.editPaymentHeader}`
    );
  }

  componentWillUnmount() {
    EditPaymentsStore_new.removeChangeListener(this.onEditStoreChange);
    window.removeEventListener('message', this.handleTokenResponse);
  }

  onEditStoreChange() {
    const editResponse = EditPaymentsStore_new.getEditPaymentResponse();
    this.setState({
      showLoader: false,
      activeData: this.state.editedData,
      isContinueDisabled: false,
    });
    switch (editResponse.code) {
      case 201:
        ManagePaymentActionCreator.setEditPayment(this.state.editedData);
        ManagePaymentActionCreator.navigateToWebTask('WEB-EDIT-PAYMENT-SUCCES');
        break;
      case 401:
      case 422:
        const { verification_type } = editResponse.error;
        verification_type === 'HARD'
          ? this.renderSoftTokenAlternative(true)
          : this.setState({ showError: true });
        break;
    }
  }

  closeErrorPopup() {
    this.setState({
      showError: false,
    });
  }

  editPayment(editedData, isSameSourceId = false) {
    this.setState({
      showLoader: true,
      editedData,
    });
    const requestPacket = ManagePaymentBL.createEditSoRequestPacket(editedData);

    ManagePaymentActionCreator.editPayment({
      requestPacket,
      accountId: editedData.fromAccountId,
      mandateId: editedData.id,
      isSameSourceId,
      paymentAmount: editedData.amount,
    });
  }

  errorPopup() {
    const response = EditPaymentsStore_new.getEditPaymentResponse();
    if (parseInt(response.error.code) === 401) {
      const messages =
        "This payment can't be made as it take you over the daily transaction limit for internet banking.";
      return this.showErrorModal(messages, true);
    } else if (parseInt(response.error.code) === 404) {
      return this.showErrorModal(response.error.code, false);
    } else {
      return (
        <ErrorPopUpComponent
          error={response.error}
          closeErrorPopup={this.closeErrorPopup}
          content={this.props.contents}
        />
      );
    }
  }

  goBack() {
    const getBackUrl = EditPaymentsStore_new.getBackUrl();
    ManagePaymentActionCreator.navigateToWebTask(getBackUrl);
  }

  handleErrorResponse() {
    const { showError, showSoftTokenAlternative } = this.state;
    return !showError || showSoftTokenAlternative ? null : this.errorPopup();
  }

  handleTokenResponse(e) {
    if (
      e.data === 'success' ||
      e.data === 'failed' ||
      e.data === 'error' ||
      e.data === 'cancel'
    ) {
      // to ignore biocatch postMessage response
      this.setState({
        showError: false,
        showSoftTokenAlternative: false,
      });
      if (e.data === 'success') {
        this.editPayment(this.state.editedData, true);
      } else if (e.data === 'error') {
        SessionActionCreator.requestAccessTokenReset(true);
      }
      if (e.data === 'failed') {
        this.setState({
          showMaxOTPReachedModal: true,
        });
      }
    }
  }

  showContent() {
    const fromData = `${this.state.activeData.fromAccountName}-${this.state.activeData.fromAccountNumber}`;
    return (
      <div className="row">
        <div className="col-xs1-24 col-md1-18">
          <StepHeader
            showheaderCrumbs
            onClick={this.goBack}
            headerCrumbsMessage="Back"
            headerTitle={this.props.content.viewPaymentHeader}
            headerSubtitle={StringConstant.editPaymentHeader}
          />
          <dl className="c-definitions">
            <dt className="c-definitions__key">From</dt>
            <dd className="c-definitions__value">{fromData}</dd>
            <dt className="c-definitions__key">To</dt>
            <dd className="c-definitions__value">
              {this.state.activeData.toAccountName}
            </dd>
            <dt className="c-definitions__key">Their sort code</dt>
            <dd className="c-definitions__value">
              {NumberUtils.formatSortCode(this.state.activeData.sortCode)}
            </dd>
            <dt className="c-definitions__key">Their account number</dt>
            <dd className="c-definitions__value">
              {this.state.activeData.accountNumber}
            </dd>
            <dt className="c-definitions__key">Type</dt>
            <dd className="c-definitions__value">
              {this.state.activeData.payType}
            </dd>
            <dt className="c-definitions__key">Repeat this payment</dt>
            <dd className="c-definitions__value">
              {this.state.activeData.soType === 'SINGLE' ? 'No' : 'Yes'}
            </dd>
          </dl>
          {this.handleErrorResponse()}
          {this.state.showSoftTokenAlternative && (
            <VerificationContainer
              onCancel={() => this.handleTokenResponse({ data: 'cancel' })}
              onSuccess={() => this.handleTokenResponse({ data: 'success' })}
            />
          )}
          {this.state.activeData.soType === 'SINGLE' ? (
            <EditSinglePayment
              activeData={this.state.activeData}
              {...this.props}
              editSinglePayment={this.editPayment}
              isContinueDisabled={this.state.isContinueDisabled}
              goBack={this.goBack}
            />
          ) : (
            <EditSOPayment
              {...this.props}
              activeData={this.state.activeData}
              editSOPayment={this.editPayment}
              goBack={this.goBack}
              isContinueDisabled={this.state.isContinueDisabled}
            />
          )}
        </div>
      </div>
    );
  }

  showErrorModal(errorText, otp) {
    let bodyContent;
    if (this.state.showMaxOTPReachedModal) {
      return this.renderMaxOtpReachedModal();
    }
    if (otp) {
      const sourceId = HashcodeUtils.getSourceIdForSoftToken();
      const accessToken =
        SessionStore.getURLTokenValue() ||
        SessionStore.getToken()['access_token'];
      const verificationType = EditPaymentsStore_new.getVerificationType();
      const bcsid = getCookieContent('bcsid');
      const softTokenURL = envConfig.softTokenURL
        .replace('{tokenParameter}', accessToken)
        .replace('{sourceId}', sourceId)
        .replace('{user_tracking_id}', AppStore.getUserTrackingID());
      const softTokenUrlWithVerificationType = `${softTokenURL}&type=${verificationType}&bcsid=${bcsid}`;
      bodyContent = (
        <iframe
          id="statements"
          width="100%"
          height="475px"
          frameBorder="0"
          src={softTokenUrlWithVerificationType}
        />
      );
      return (
        <PatternLibModalComponent
          show
          customClass={'c-modal c-modal--iframe'}
          bsSize={'medium'}
          modalBody={bodyContent}
          modalInContainer={false}
          closeButton={false}
        />
      );
    } else if (errorText === '404') {
      const data = this.props.content.downloadMobileAppForSoftTokenText.replace(
        '<payment>',
        'payment'
      );
      const heading = this.props.content.softTokenErrorHeading.replace(
        '<payment>',
        'payment'
      );
      const bodyContent = (
        <div className="u-flex u-justify-center">
          <span className="icon icon-attention u-margin-top-b u-margin-bottom-b" />
          <p
            className="text-center"
            dangerouslySetInnerHTML={{ __html: data }}
          />
        </div>
      );
      const footerButtons = (
        <div>
          <div className="u-flex u-justify-content u-margin-bottom-b">
            <button
              type="button"
              onClick={this.closeErrorPopup}
              className="c-btn c-btn--default c-btn--secondary c-modal__button"
            >
              {this.props.content.reduceAmountButton}
            </button>
          </div>
          <p
            className="text-center"
            dangerouslySetInnerHTML={{
              __html: this.props.content.knowMoreText,
            }}
          />
        </div>
      );
      return (
        <PatternLibModalComponent
          customClass={'c-modal'}
          onHide={this.closeErrorPopup}
          bsSize={'large'}
          show={this.props.showErrorModalState}
          modalHeading={heading}
          modalBody={bodyContent}
          modalInContainer={false}
          modalFooter={footerButtons}
          closeButton
        />
      );
    }
  }

  renderMaxOtpReachedModal() {
    const footerButtons = (
      <button
        type="button"
        onClick={() => SessionActionCreator.requestAccessTokenReset(true)}
        className="c-btn c-btn--default c-modal__button"
      >
        OK
      </button>
    );
    const {
      content: { authorisationFailedHeader, authorisationFailedBody },
    } = this.props;
    return (
      <PatternLibModalComponent
        show
        customClass={'c-modal c-modal--iframe'}
        bsSize={'medium'}
        modalHeading={authorisationFailedHeader}
        modalBody={authorisationFailedBody}
        modalInContainer={false}
        modalFooter={footerButtons}
        closeButton={false}
      />
    );
  }

  renderSoftTokenAlternative(showSoftTokenAlternative) {
    this.setState({
      ...this.state,
      showSoftTokenAlternative,
      showError: showSoftTokenAlternative,
    });
  }

  render() {
    return (
      <div>
        <Helmet title="Edit a payment" />
        <div className="bow page">
          <div
            className="container managepayment-container"
            id="site-main"
            role="main"
            tabIndex="-1"
          >
            {this.state.showLoader ? (
              <LoaderComponent type="large" />
            ) : (
              this.showContent()
            )}
          </div>
        </div>
      </div>
    );
  }
}

EditPayment.propTypes = {
  isSMEUser: PropTypes.bool.isRequired,
  envConfig: PropTypes.shape({
    brandId: PropTypes.string.isRequired,
  }).isRequired,
  session: PropTypes.shape({
    accessToken: PropTypes.string.isRequired,
  }).isRequired,
  content: PropTypes.shape({
    authorisationFailedHeader: PropTypes.string.isRequired,
    authorisationFailedBody: PropTypes.string.isRequired,
  }).isRequired,
};

export default RequiresAuthenticatedUser(EditPayment);
